<template>
  <div>
    <!-- 检品单调配 -->
    <el-dialog :title="$t('message.inspectionListDeployment')" :close-on-click-modal="false" :visible.sync="editDialog"
      center width="600px">
      <!-- 检品员 -->
      <div class="selectBox">
        <label>{{ $t("message.inspector") }}</label>
        <el-select v-model="value" placeholder="" filterable>
          <el-option v-for="item in J" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="btns">
        <!-- 确认 -->
        <el-button type="primary" @click="confirm">{{
          $t("message.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editDialog: false,
      value: "",
    };
  },
  components: {},
  computed: {
    J() {
      return this.$store.state.authWorkGroupAdmin.j;
    },
  },
  created() {
    this.$store.dispatch("getAuthWorkGroupAdmin");
  },
  methods: {
    open() {
      this.editDialog = true;
    },
    // 确认修改
    confirm() {
      // 是否确认修改?
      this.$confirm(this.$t("message.doYouWantToConfirmTheModification"), {
        type: "warning",
      })
        .then(() => {
          this.$api.inspectionApi
            .inspectDispatchAdmin({
              inspect_sn: this.$route.query.id,
              j_id: this.value,
            })
            .then((res) => {
              ////console.log('inspectDispatchAdmin',res)
              this.$message.success(res.msg);
              //接下来的操作
              this.editDialog = false;
              this.$parent.getData();
              this.$parent.checked = false;
            });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.selectBox {
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    margin-right: 10px;
  }
}

.btns {
  text-align: right;
}
</style>